<template>
  <div class="wrapper">
    <!-- 1.顶部标题 -->
    <el-row>
      <h3 class="title">
        <div class="block">
          <span>路由策略应用</span>
        </div>
      </h3>
    </el-row>
    <!-- 3.工具栏 -->
    <el-row class="table-tool" type="flex" justify="end">
      <el-button size="small" type="info" @click="addNewAcdApply" icon="el-icon-plus">新增路由策略应用</el-button>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
    <!-- 3.表格区 -->
    <el-row>
      <el-table style="width:100%;" :data="tableData">
        <el-table-column
          prop="platformNames"
          label="渠道"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column prop="acdName" label="调用策略名称" align="center" :show-overflow-tooltip="true" />
        <el-table-column
          prop="editorName"
          label="最后编辑人"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="editTime"
          label="最后编辑时间"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column prop="operation" label="操作" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="编辑" placement="bottom">
              <el-button
                type="text" @click="editPlatformAcds(scope.row)"
              >
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <el-button
                type="text" @click="_deletePlatformAcds(scope.row)"
              >
                <svg class="icon icon-delete" aria-hidden="true">
                  <use xlink:href="#icontable-delete" />
                </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页栏 -->
      <el-row style="float:right;">
        <el-pagination
          background
          class="pageStyle"
          layout="total, prev, pager, next, jumper"
          :page-size.sync="pageSize"
          :current-page.sync="pageNum"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-row>

    </el-row>
    </el-scrollbar>
  </div>
</template>
<script>
import { listPlatformAcds, deletePlatformAcdById } from '@/api/user'
export default {
  name: 'platformApplyList',
  data() {
    return {
      channels: [],
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // 1.表格内数据
      tableData: []
    }
  },
  mounted() {
    this._listPlatformAcds()
  },
  methods: {
    // 分页栏点击事件
    handleCurrentChange(val) {
      this.pageNum = val
      this._listPlatformAcds()
    },
    addNewAcdApply() {
      this.$store.commit('user/setCurPlatformAcdId', { curPlatformAcdId: '' })
      this.$store.commit('user/setPlatformApplyAcdPageIndex', { platformApplyAcdPageIndex: 2 })
    },
    _listPlatformAcds() {
      listPlatformAcds({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(
        res => {
          if (res.code === 2000) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    editPlatformAcds(row) {
      this.$store.commit('user/setCurPlatformAcdId', { curPlatformAcdId: row.id })
      this.$store.commit('user/setPlatformApplyAcdPageIndex', { platformApplyAcdPageIndex: 2 })
    },
    _deletePlatformAcds(row) {
      this.$confirm('请您确认是否需要删除？', '', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning',
        showClose: false
      })
        .then(() => {
          deletePlatformAcdById({
            id: row.id
          }).then(
            res => {
              if (res.code === 2000) {
                this.$message.success(res.data)
                this._listPlatformAcds()
              } else {
                this.$message.error(res.msg)
              }
            }
          )
        })
        .catch(() => {})
    }

  }
}
</script>
<style scoped lang="scss">
.table-tool{
  margin:10px 0;
}
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 61px - 78px);
}
</style>
